import { render } from "./KindergartenDirectorPage.vue?vue&type=template&id=490be795&scoped=true"
import script from "./KindergartenDirectorPage.vue?vue&type=script&lang=js"
export * from "./KindergartenDirectorPage.vue?vue&type=script&lang=js"

import "./KindergartenDirectorPage.vue?vue&type=style&index=0&id=490be795&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490be795"]])

export default __exports__